import type { PaymentsAppMessage } from '../types';

export const LAST_STARTED_TRANSACTION = 'lastStartedTransaction';

const SUPPORTED_CLASSES = new Set(['fail', 'flow', 'analytics']);

export function isPaymentsAppMessage(msg: unknown): msg is PaymentsAppMessage {
  if (!msg || typeof msg !== 'object') {
    return false;
  }

  if ('action' in msg && typeof msg.action === 'string') {
    return true;
  }

  if ('type' in msg && msg.type === 'fail' && 'message' in msg && typeof msg.message === 'string') {
    return true;
  }

  return 'class' in msg && SUPPORTED_CLASSES.has(msg.class as never) && 'type' in msg && typeof msg.type === 'string';
}

const DEFAULT_FOREIGN_HTML_HEIGHT = '90vw';
const CARD_ADAPTER_HEIGHT = 732;
const ALTERNATE_PAYMENTS_HEIGHT = 774.5;
const SAFECHARGE_HEIGHT = 774.5;

export function assumeForeignHtmlStyle(foreignUrl?: string): {
  height?: string | number;
  background?: string;
} {
  if (!foreignUrl) {
    return { height: DEFAULT_FOREIGN_HTML_HEIGHT };
  }

  if (foreignUrl.includes('paysafe.com/cardadapter/v1/authentication/app')) {
    return {
      height: CARD_ADAPTER_HEIGHT,
      background: 'white',
    };
  }

  if (foreignUrl.includes('paysafe.com/alternatepayments/v1/redirect')) {
    return {
      height: ALTERNATE_PAYMENTS_HEIGHT,
      background: 'white',
    };
  }

  if (foreignUrl.includes('safecharge.com')) {
    return {
      height: SAFECHARGE_HEIGHT,
      background: 'white',
    };
  }

  return {
    height: DEFAULT_FOREIGN_HTML_HEIGHT,
    background: 'white',
  };
}

export function getIframeMaxHeight() {
  return Math.min(
    document.documentElement.clientHeight ?? Number.MAX_VALUE,
    window.innerHeight ?? Number.MAX_VALUE,
    800,
  );
}
